export enum OrderType {
  purchaseRequest = 'PR',
  assistedOrder = 'CT',
  purchaseOrder = 'CPO',
  wmsRequest = 'WMSRQ',
  freightquotation = 'FRQ',
  freightRequest = 'FRR'
}
